import React, { useMemo } from 'react';
import QBDealPicker, { QBDealOption } from '../sales-activity/QBDealPicker';
import {
  CONTRACTOR_OTHER_PROJECT_ID,
  CONTRACTOR_OTHER_PROJECT_LABEL,
  type ContractorProjectOption,
} from '../../utils/contractorProjectPicker';

interface ContractorProjectPickerProps {
  value: string;
  onChange: (projectId: string) => void;
  options: ContractorProjectOption[];
  disabled?: boolean;
  suggestedIds?: string[];
  'aria-label'?: string;
}

const ContractorProjectPicker: React.FC<ContractorProjectPickerProps> = ({
  value,
  onChange,
  options,
  disabled,
  suggestedIds,
  'aria-label': ariaLabel = 'Project',
}) => {
  const dealOptions: QBDealOption[] = useMemo(
    () =>
      options.map((o) => ({
        id: o.id,
        label: o.label,
        searchText: o.searchText,
      })),
    [options],
  );

  return (
    <QBDealPicker
      value={value}
      onChange={onChange}
      dealOptions={dealOptions}
      specialOptions={[{ id: CONTRACTOR_OTHER_PROJECT_ID, label: CONTRACTOR_OTHER_PROJECT_LABEL }]}
      emptyLabel="Select project…"
      disabled={disabled}
      suggestedIds={suggestedIds}
      aria-label={ariaLabel}
    />
  );
};

export default ContractorProjectPicker;
